module.exports = __webpack_public_path__ + "img/icon_sub_01.d2e7e92a.jpg";